import { Form, Formik } from "formik";
import * as Yup from "yup";
import { FiUserPlus } from "react-icons/fi";
import { Input } from "../../../components/Input";
import { Modal, ModalButton } from "../../../components/Modal";
import { api } from "../../../services/api";

interface ModalAddResponsibleProps {
  setModalAddResponsible(showModal: boolean): void;
  costumer_id: string;
}

interface Responsible {
  newResponsible_name: string;
}

const schema = Yup.object().shape({
  newResponsible_name: Yup.string().required(
    "Nome do responsável é obrigatório",
  ),
});

export function ModalAddResponsible({
  setModalAddResponsible,
  costumer_id,
}: ModalAddResponsibleProps) {
  const initialValues: Responsible = {
    newResponsible_name: "",
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={schema}
      onSubmit={() => {
        // Submit handled by button onClick
      }}
    >
      {({ errors, values }) => (
        <Modal
          isOpen
          onClose={() => setModalAddResponsible(false)}
          title="Novo Responsável"
          icon={<FiUserPlus size={24} />}
          variant="primary"
          footer={
            <>
              <ModalButton
                variant="cancel"
                onClick={() => setModalAddResponsible(false)}
              >
                Cancelar
              </ModalButton>
              <ModalButton
                variant="success"
                onClick={async () => {
                  if (!values.newResponsible_name) return;
                  await api.post("/responsibles", {
                    costumer_id,
                    name: values.newResponsible_name,
                    email: "",
                    phone: 0,
                  });
                  setModalAddResponsible(false);
                }}
              >
                Salvar
              </ModalButton>
            </>
          }
        >
          <Form>
            <div className="space-y-4">
              <div>
                <span className="block text-sm font-medium text-gray-700 mb-1">
                  Nome do Responsável
                </span>
                <Input
                  type="text"
                  name="newResponsible_name"
                  placeholder="Digite o nome do responsável"
                  error={errors.newResponsible_name}
                  className="h-[52px] px-4 w-full rounded-lg text-[#7FA5B2] bg-white border border-gray-200 focus:border-[#0085BD] focus:ring-1 focus:ring-[#0085BD]"
                />
              </div>
            </div>
          </Form>
        </Modal>
      )}
    </Formik>
  );
}
